const rxjs = require("rxjs"),
  cv = require('./assets/cv');

let subject = new rxjs.Subject(),
  historyIndex = -1;

const openFlags = ['-o', '--open'],
  linkFlags = ['-l', '--link'],
  downloadFlag = ['-d', '--download'],
  cmdHistory = [];

const terminal = (input, { externalLinks, commands }, callback) => {
  const {
    downloadFile,
    cvUrlOpen,
  } = externalLinks;
  const { whoami, skills, experience, help } = commands,
    [command, flag] = input.trim().toLowerCase().split(" ")

  addCDM(input);

  switch (command) {
    case "cv":
      if (downloadFlag.includes(flag)) {
        downloadCV(downloadFile);
        callback({ info: "Downloading CV ..." });
        return;
      }

      openUrl(cvUrlOpen);
      callback({ info: "Opened CV ..." });
      break;

    case "whoami":
      callback({ info: whoami });
      break;

    case "skills":
      callback({
        info: skills,
        component: "skills"
      });
      break;

    case "experience":
      callback({
        info: experience,
        component: "experience"
      });
      break;

    case "clear":
      callback({ info: "clear" });
      break;

    case "exit":
      callback({ info: "exit" });
      break;

    case "help":
      callback({
        info: help,
        component: "commandPreview"
      });
      break;

    case "github":
    case "linkedin":
    case "npm":
    case "blog":
    case "twitter":

      if (openFlags.includes(flag)) {
        openUrl(externalLinks[command]);
        callback({ info: `Opened ${externalLinks[command]} ...` });
        break;
      }

      if (!flag || linkFlags.includes(flag)) {
        callback({
          info: {
            link: externalLinks[command]
          },
          component: 'openLink'
        });
        break;
      }

      callback({
        info: `${flag}: unknown flag`
      });
      break;

    case "":
      callback("");
      break;

    default:
      callback({
        info: `${input}: command not found`
      });
      break;
  }
};

const downloadCV = (cvName) => {
  let timeout;

  try {
    const link = document.createElement("a");

    link.href = 'data:application/octet-stream;base64,' + cv;
    link.setAttribute("download", cvName); //or any other extension
    document.body.appendChild(link);

    timeout = setTimeout(() => {
      link.click();
      subject.next("Done");
    }, 1000);

  } catch (error) {
    clearInterval(timeout);
    subject.next("error");
  }
};

const openUrl = url => {
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("target", "_blank"); //or any other extension
  document.body.appendChild(link);

  link.click();
};

const navigateCommands = cmd => {
  if (cmd + historyIndex <= cmdHistory.length && cmd + historyIndex >= 0) historyIndex += cmd;

  return cmdHistory[historyIndex] || '';
};

const addCDM = (input) => {
  if (!input) return;
  cmdHistory.push(input);
  historyIndex = cmdHistory.length;
}

module.exports = {
  terminal,
  event: subject,
  navigateCommands
};
